import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelivery = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 98,
	height: 64,
	viewBox: "0 0 98 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M94.3342 46.2701H93.4622V32.2442C93.4622 31.2631 93.1488 30.3047 92.5674 29.5099L81.4302 14.3575C80.6899 13.3537 79.518 12.7587 78.2689 12.7587H63.321V5.56408C63.321 3.71092 61.8176 2.21204 59.969 2.21204H7.81239C5.95922 2.21204 4.46034 3.71546 4.46034 5.56408V46.2701H3.58827C2.82974 46.2701 2.21204 46.8833 2.21204 47.6463V51.7524C2.21204 52.5109 2.8252 53.1286 3.58827 53.1286H13.7671C13.7671 57.7797 17.537 61.5496 22.188 61.5496C26.8391 61.5496 30.609 57.7797 30.609 53.1286H67.3089C67.3089 57.7797 71.0789 61.5496 75.7299 61.5496C80.381 61.5496 84.1509 57.7797 84.1509 53.1286H94.3297C95.0882 53.1286 95.7059 52.5154 95.7059 51.7524V47.6463C95.7059 46.8878 95.0928 46.2701 94.3297 46.2701H94.3342Z",
			stroke: "white",
			strokeWidth: 4.42397,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.81238 2.21204H59.9689C61.8221 2.21204 63.321 3.71546 63.321 5.56408V43.7856H4.45581V5.56408C4.45581 3.71092 5.95921 2.21204 7.80783 2.21204H7.81238Z",
			fill: "url(#paint0_linear_43_305)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.3342 46.2701H3.58827C2.82819 46.2701 2.21204 46.8863 2.21204 47.6464V51.7479C2.21204 52.508 2.82819 53.1241 3.58827 53.1241H94.3342C95.0943 53.1241 95.7105 52.508 95.7105 51.7479V47.6464C95.7105 46.8863 95.0943 46.2701 94.3342 46.2701Z",
			fill: "url(#paint1_linear_43_305)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M78.2644 12.7633H63.3165V41.9007H4.45129V51.1211H93.4576V32.2488C93.4576 31.2677 93.1442 30.3093 92.5629 29.5145L81.4257 14.3621C80.6853 13.3583 79.5135 12.7633 78.2644 12.7633Z",
			fill: "url(#paint2_linear_43_305)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.1881 61.5496C26.8389 61.5496 30.6091 57.7794 30.6091 53.1286C30.6091 48.4779 26.8389 44.7076 22.1881 44.7076C17.5373 44.7076 13.7671 48.4779 13.7671 53.1286C13.7671 57.7794 17.5373 61.5496 22.1881 61.5496Z",
			fill: "url(#paint3_linear_43_305)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.188 57.3845C24.5385 57.3845 26.444 55.4791 26.444 53.1286C26.444 50.7781 24.5385 48.8727 22.188 48.8727C19.8376 48.8727 17.9321 50.7781 17.9321 53.1286C17.9321 55.4791 19.8376 57.3845 22.188 57.3845Z",
			fill: "url(#paint4_linear_43_305)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.73 61.5496C80.3808 61.5496 84.151 57.7794 84.151 53.1286C84.151 48.4779 80.3808 44.7076 75.73 44.7076C71.0792 44.7076 67.309 48.4779 67.309 53.1286C67.309 57.7794 71.0792 61.5496 75.73 61.5496Z",
			fill: "url(#paint5_linear_43_305)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.7299 57.3845C78.0804 57.3845 79.9858 55.4791 79.9858 53.1286C79.9858 50.7781 78.0804 48.8727 75.7299 48.8727C73.3794 48.8727 71.474 50.7781 71.474 53.1286C71.474 55.4791 73.3794 57.3845 75.7299 57.3845Z",
			fill: "url(#paint6_linear_43_305)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.069 16.9284H77.1516C77.9874 16.9284 78.7731 17.319 79.2773 17.9867L87.0669 28.3244C87.6574 29.1057 87.0988 30.223 86.1222 30.223H66.069V16.9238V16.9284Z",
			fill: "url(#paint7_linear_43_305)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_43_305",
				x1: 8.3529,
				y1: 4.09245,
				x2: 82.9882,
				y2: 61.8539,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#D7E8EA" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .26,
						stopColor: "#D3E4E6"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .49,
						stopColor: "#C9D9DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .72,
						stopColor: "#B8C6C8"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .94,
						stopColor: "#A0ACAE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#98A4A6"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_43_305",
				x1: 48.959,
				y1: 41.8416,
				x2: 48.959,
				y2: 78.5415,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#F2D455" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .15,
						stopColor: "#EBBA4A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .39,
						stopColor: "#E1973B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .62,
						stopColor: "#DB7E31"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .83,
						stopColor: "#D76F2B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#D66A29"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_43_305",
				x1: 48.959,
				y1: 41.8416,
				x2: 48.959,
				y2: 78.5415,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#F2D455" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .15,
						stopColor: "#EBBA4A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .39,
						stopColor: "#E1973B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .62,
						stopColor: "#DB7E31"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .83,
						stopColor: "#D76F2B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#D66A29"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_43_305",
				x1: 16.0699,
				y1: 48.3913,
				x2: 33.8657,
				y2: 62.1628,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .18,
						stopColor: "#40201C"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .55,
						stopColor: "#633328"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .92,
						stopColor: "#8B4A37"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_43_305",
				x1: 19.0949,
				y1: 50.7349,
				x2: 28.0882,
				y2: 57.6934,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#D7E8EA" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .26,
						stopColor: "#D3E4E6"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .49,
						stopColor: "#C9D9DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .72,
						stopColor: "#B8C6C8"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .94,
						stopColor: "#A0ACAE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#98A4A6"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_43_305",
				x1: 69.6118,
				y1: 48.3913,
				x2: 87.4076,
				y2: 62.1628,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .18,
						stopColor: "#40201C"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .55,
						stopColor: "#633328"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .92,
						stopColor: "#8B4A37"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_43_305",
				x1: 72.6413,
				y1: 50.7349,
				x2: 81.6301,
				y2: 57.6934,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#D7E8EA" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .26,
						stopColor: "#D3E4E6"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .49,
						stopColor: "#C9D9DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .72,
						stopColor: "#B8C6C8"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .94,
						stopColor: "#A0ACAE"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#98A4A6"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_43_305",
				x1: 65.8827,
				y1: 18.7952,
				x2: 91.7226,
				y2: 38.7893,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#F2D455" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .15,
						stopColor: "#EBBA4A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .39,
						stopColor: "#E1973B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .62,
						stopColor: "#DB7E31"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .83,
						stopColor: "#D76F2B"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#D66A29"
					})
				]
			})
		] })
	]
});
export default SvgDelivery;
